import { createAction, props } from '@ngrx/store';
import { NotificationChannel, NotificationMessage } from '../models/notification.model';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('Notifications');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const createNotificationChannel = createAction(
  withNameSpace('Create notification channel')
);

export const notificationChannelCreated = createAction(
  withNameSpace('Notification channel created'),
  props<{ channel: NotificationChannel }>()
);

export const connectToNotificationChannel = createAction(
  withNameSpace('Connect to notification channel'),
  props<{ channel: NotificationChannel, isReconnect: boolean }>()
);

export const connectToNotificationChannelSuccess = createAction(
  withNameSpace('Connect to notification channel success'),
  props<{ isReconnect: boolean }>()
);

export const subscribeToNotifications = createAction(
  withNameSpace('Subscribe to notifications'),
  props<{ userId: string, channelId: string, topics: string[] }>()
);

export const subscribeToNotificationsSuccess = createAction(
  withNameSpace('Subscribe to notifications success'),
  props<{ topics: string[] }>()
);

export const notificationArrived = createAction(
  withNameSpace('Notification arrived'),
  props<{ notification: NotificationMessage<any, any> }>()
);

export const notificationChannelError = createAction(
  withNameSpace('Notification channel error'),
  props<{ channel: NotificationChannel }>()
);
